import type { FontValue } from '@elfsight/configurator-contracts';
import { useFontsLoader } from '@elfsight/widget-ui';
import type { BlockProps } from '../blocks';

export function useFonts(blocks?: BlockProps[]) {
  const fontFamilies = blocks
    ?.map((block) => {
      if ('buttonProps' in block) {
        return block.buttonProps.fontFamily;
      }

      if ('fontFamily' in block) {
        return block.fontFamily;
      }

      if (block.type === 'form' && 'font' in block) {
        return block.font;
      }

      return;
    })
    .filter(Boolean) as FontValue[];

  const uniqueFontFamilies = [...new Set(fontFamilies)];

  useFontsLoader(uniqueFontFamilies);
}
